module.exports = __webpack_public_path__ + "static/media/WM1@1.5x.8060649d.png";